"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seeker = void 0;
/**
 * Minimal token traverse helper used to create structure from tokens
 */
class Seeker {
    constructor(tokens) {
        this.tokens = tokens;
        this.index = -1;
    }
    next() {
        this.index++;
        return this.tokens[this.index] || { type: '' };
    }
    back() {
        this.index--;
    }
    peekBack() {
        return this.tokens[this.index - 1] || { type: '' };
    }
    peek(num = 1) {
        return this.tokens[this.index + num] || { type: '' };
    }
    take(type) {
        if (this.peek().type === type) {
            return this.next();
        }
        return undefined;
    }
    eat(type) {
        while (this.peek().type === type) {
            this.index++;
        }
        return this;
    }
    takeMany(type) {
        const tokens = [];
        while (this.peek().type === type) {
            tokens.push(this.next());
        }
        return tokens;
    }
    flatBlock(start, end, isEndError) {
        let token = this.next();
        if (token.type !== start) {
            return [];
        }
        const block = [];
        let endIndex;
        while ((token = this.next())) {
            if (!token.type) {
                if (endIndex !== undefined) {
                    this.index = endIndex - 1;
                }
                return;
            }
            if (isEndError && isEndError(token)) {
                endIndex = this.index;
            }
            if (token.type === end) {
                return block;
            }
            else {
                block.push(token);
            }
        }
        return [];
    }
    done() {
        return this.index >= this.tokens.length - 1;
    }
    run(handleToken, ast, source) {
        let token;
        while ((token = this.next()) && token.type) {
            if (handleToken(token, ast, source, this) === false) {
                break;
            }
        }
        return ast;
    }
}
exports.Seeker = Seeker;
//# sourceMappingURL=seeker.js.map